import { FaBars, FaSearch, FaUser } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../http/authcontex';
import './common.css';
import './style.css';

export default function TopNav({ toggleSidebar, isSidebarOpen }) {
    const authContext = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        authContext.logout();
        navigate('');
    };

    return (
        <div className={`TopNav ${isSidebarOpen ? 'sb-sidenav-toggled' : ''}`}>
            <nav className="sb-topnav navbar navbar-expand navbar-dark bg-dark">
                {/* Navbar Brand */}
                <a className="navbar-brand ps-3" href="/"> {/* Add href to make it navigable */}
                    <img src="/apitco_logo.png" alt="APITCO Logo" style={{ height: '50px', marginRight: '10px' }} />
                </a>
                {/* Sidebar Toggle */}
                <button 
                    className="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0" 
                    id="sidebarToggle" 
                    onClick={toggleSidebar}
                    aria-label="Toggle Sidebar"
                >
                    <FaBars />
                </button>
                {/* Navbar Search */}
                <form className="d-none d-md-inline-block form-inline ms-auto me-0 me-md-3 my-2 my-md-0">
                    <div className="input-group">
                        <input className="form-control" type="text" placeholder="Search for..." aria-label="Search for..." aria-describedby="btnNavbarSearch" />
                        <button className="btn btn-primary" id="btnNavbarSearch" type="button">
                            <FaSearch />
                        </button>
                    </div>
                </form>
                {/* Navbar */}
                <ul className="navbar-nav ms-auto ms-md-0 me-3 me-lg-4">
                    <li className="nav-item dropdown">
                        <button 
                            className="nav-link dropdown-toggle" 
                            id="navbarDropdown" 
                            type="button" 
                            data-bs-toggle="dropdown" 
                            aria-expanded="false"
                        >
                            <FaUser />
                        </button>
                        <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                            <li>
                                <button className="dropdown-item" onClick={handleLogout}>
                                    Logout
                                </button>
                            </li>
                        </ul>
                    </li>
                </ul>
            </nav>
        </div>
    );
}
